import { useEffect } from 'react'


type hookFunctionEntity = () => void;
const useOverrideBrowserZoom = (zoomIn: hookFunctionEntity, zoomOut: hookFunctionEntity, restartZoom: hookFunctionEntity) => {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.ctrlKey) {
                if (e.key === "+" || e.key === "=") {
                    e.preventDefault();
                    zoomIn();
                }
                if (e.key === "-") {
                    e.preventDefault();
                    zoomOut()
                }
                if (e.key === "0") {
                    e.preventDefault();
                    restartZoom()
                }
            }
        };

        const handleWheel = (e: WheelEvent) => {
            if (!e.ctrlKey) {
                return;
            }

            e.preventDefault();

            if (e.deltaY < 0) {
                zoomIn();
                return;
            }

            if (e.deltaY > 0) {
                zoomOut();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("wheel", handleWheel, { passive: false });
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("wheel", handleWheel);
        };
    }, [zoomIn, zoomOut, restartZoom]);
}

export default useOverrideBrowserZoom
